// Charge la base commune
import './common.js'

// Styles custom
import './scss/pages/grounds.scss'

// Scripts librairies
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'
import { dtectMap } from './js/libs/utils'
import { groundsPage } from './js/pages/grounds.page.js'

// rafraîchissement
function r () {
  Waypoint.refreshAll()
}

// OwlCarousel
function getOwlCarousel () {
  import(/* webpackChunkName: "owl-carousel" */ './js/components/owl-carousel.js').then(() => {
    r()
  })
}

// Cities
function getSearchOffers () {
  import('./js/components/offers-search-form.js').then(module => {
    module.offersSearchForm.init($('form[name="ground_filters_form"]'))
  })
}

// Custom Lists
function getCustomLists () {
  import('./js/components/custom-lists.js')
}

// Contact Form
function getContactForm () {
  const $f = $('form[name="contact_form"]')
  $f.find('button, input, textarea, select').prop('disabled', true).css({ opacity: 0.5 })
  import('./js/components/contact-form.js').then(() => {
    $f.find('button, input, textarea, select').prop('disabled', false).css({ opacity: 1 })
  })
}

// Alert Form
function getAlertForm () {
  const $f = $('form[name="offer_alert_form"]')
  $f.find('button, input, select').prop('disabled', true).css({ opacity: 0.5 })
  import('./js/components/offer-alert-form.js').then(() => {
    $f.find('button, input, select').prop('disabled', false).css({ opacity: 1 })
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  let $f
  // gestion des carousel
  $f = $('div.owl-carousel')
  if ($f.length) {
    $f.waypoint(function () {
      getOwlCarousel()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // Filtres des offres autocomplete
  $('form[name="ground_filters_form"] input[name="search"]').on('click', function () {
    $(this).blur().attr('disabled', '')
    getSearchOffers()
    $(this).off('click')
  })

  // à exécuter une fois la GMap API correctement chargée
  if ($('#map').length || $('#map-detail').length) {
    dtectMap(function () {
      groundsPage.initMap()
    })
    groundsPage.init()
  } else {
    if ($('#go').length) {
      const t = $('#go')
      $('html, body').animate({
        scrollTop: ($(t).offset().top - $('#navigation4').height() - 120)
      }, 500)
    }
  }

  // gestion des scrollbars améliorées
  $f = $('.custom-lists')
  if ($f.length) {
    $f.waypoint(function () {
      getCustomLists()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  $f = $('form.contact-form')
  if ($f.length) {
    $f.waypoint(function () {
      getContactForm()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire des alertes
  $f = $('form.offer-alert-form')
  if ($f.length) {
    $f.waypoint(function () {
      getAlertForm()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // refresh waypoints au chargement d'une image
  $('.lazyload').on('lazyloaded', () => {
    r()
  })
  setTimeout(function () {
    r()
  }, 500)
})
